import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ArticleDetailPage from "../pages/article-detail/page";
import ComparisonPage from "../pages/comparison/page";
import ShoppingGuidePage from "../pages/shopping-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/vigorbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/article/:slug",
    element: <ArticleDetailPage />,
  },
  {
    path: "/kakobuy-vs-vigorbuy",
    element: <ComparisonPage />,
  },
  {
    path: "/shopping-guide",
    element: <ShoppingGuidePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;